import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { ILayoutState } from '../../Store/Layout/Types';
import { IUserState } from '../../Store/User/Types';
import { getACLParents, getACLUsers } from '../../Store/UserManagement/Actions';
import {
	IUserManagementState,
	IUserSearchParams,
	IUserSearchParamsSorting,
} from '../../Store/UserManagement/Types';
import { getTheme } from '../../Themes';
import { DrawerUser } from './DrawerUserManagement';
import { DrawerChannel } from './DrawerChannelManagement';
import { Route } from 'react-router-dom';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	layout: ILayoutState;
	localeInfos: ILocaleInfos;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	userManagement: IUserManagementState;
}

interface IState {
	params: IUserSearchParams;
	parentName: string;
}

interface IPropsTheme {
	theme: any;
}

interface IPropsFromDispatch {
	getACLUsers: typeof getACLUsers;
	getACLParents: typeof getACLParents;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IPropsTheme &
	IConnectedReduxProps;

const theme = getTheme();
const styles = MD.createStyles({
	drawerPaper: {
		width: theme.UserManagement.dimensions.drawerWidth,
		paddingTop: '14px',
		paddingLeft: '15px',
		paddingRight: '15px',
		backgroundColor: theme.palette.background.default,
	},
	launchSearch: {
		marginTop: '20px',
	},
	formControl: {
		margin: theme.spacing(3),
	},
	formLabel: {
		marginBottom: theme.spacing(2),
	},
});

export class DrawerComponent extends React.Component<AllProps, IState> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			parentName: '',
			params: {
				isGroup: this.props.router.match.params.type === 'groups',
				researchText: '',
				showInactive: false,
				usersParentID: 0,
				createdAfter: undefined,
			},
		};
	}

	public selected(): React.ReactNode {
		switch (this.props.router.match.params.type) {
			case 'users':
				return <Route component={DrawerUser} />;
			case 'groups':
				return <Route component={DrawerUser} />;
			case 'channels':
				return <Route component={DrawerChannel} />;
			default:
				return;
		}
	}

	public render(): React.ReactNode {
		const { classes } = this.props;
		return (
			<MD.Drawer
				anchor="left"
				classes={{
					paper: classes.drawerPaper,
				}}
				open={this.props.layout.showDrawer}
				variant="persistent"
			>
				<MD.FormControl
					component="fieldset"
					className={classes.formControl}
				>
					<MD.FormLabel
						component="legend"
						className={classes.formLabel}
					>
						{this.props.i18n._('Research Fields')}
					</MD.FormLabel>
					{this.selected()}
				</MD.FormControl>
			</MD.Drawer>
		);
	}
}

const mapStateToProps = (
	{ i18n, layout, router, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	localeInfos: i18n.localeInfos,
	layout,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLUsers: (
		token: string,
		params: IUserSearchParams | null,
		paramsSorting: IUserSearchParamsSorting | null,
		resultsPerPage?: number,
		page?: number
	) =>
		dispatch(
			getACLUsers(token, params, paramsSorting, resultsPerPage, page)
		),
	getACLParents: (token: string, researchField: string) =>
		dispatch(getACLParents(token, researchField)),
});

export const Drawer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(DrawerComponent)));
